/**
 * The colour of an issuer's lifecycle status, which is a plain string the issuer chooses, not an enum.
 *
 * `soon` is a tranche that has been announced but whose subscription window has not opened (MYG-891);
 * staff have to be able to tell it from a closed one at a glance, and grey said neither. A map rather
 * than a chain, as the other status tags in this app are written — the next lifecycle word is then a
 * one-line edit.
 *
 * Since the page tags the state customers are served (MYG-902), a word outside the three the app knows
 * is one the order gate refuses to sell under, so it gets a colour of its own instead of closed's grey.
 */
const ISSUER_STATUS_COLORS: Record<string, string> = {
  open: 'green',
  soon: 'orange',
  closed: 'default',
};

export function issuerStatusColor(status: string): string {
  return ISSUER_STATUS_COLORS[status] || 'purple';
}

/**
 * Whether the mirror's stored word says something other than the state served. Lympid's "active" is
 * served as "open", so a live Lympid row is no divergence — tagging every one of them would teach staff
 * to ignore the tag that matters (MYG-902 review).
 */
export function mirrorWordDiffers(mirrorWord: string | undefined, served: string): boolean {
  const word = mirrorWord?.trim().toLowerCase();
  if (!word) return false;
  return (word === 'active' ? 'open' : word) !== served;
}
